import EbzFilterGroup from './EbzFilterGroup';

export default EbzFilterGroup;
